import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes, faAngleLeft } from '@fortawesome/pro-light-svg-icons';

// Actions
import {
  createAgent,
  loadAgents,
} from '../../../actions/agent';

// Components
import AccessPanel from '../user-details/access/AccessPanel';
import Spinner from '../../../common/components/Spinner';

export default function AddUserPermissions() {
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const {
    adduser: {
      errors,
      saving,
      validations,
      values = {},
    },
    agents: {
      sortTerm,
      sortInverse,
    },
  } = useSelector(store => store);

  function close() {
    dispatch({ type: 'CLEAR_ADD_USER' });
    dispatch({ type: 'CLOSE_MODAL', modal: 'addUserOpen' });
    // Reload entire Agent list for proper placement
    loadAgents({ sort: sortTerm, desc: sortInverse });
  }

  function handleSave() {
    dispatch({ type: 'ADD_USER_SAVE' });
    createAgent({ ...values })
      .then(() => close())
      .finally(() => dispatch({ type: 'ADD_USER_CLEAR_SAVE' }));
  }

  const errorValidations = {
    first_name: validations.first_name,
    middle_name: validations.middle_name,
    last_name: validations.last_name,
    email: validations.email,
    mobile_phone: validations.mobile_phone,
    npn: validations.npn,
    agency: validations.agency,
  };
  const erroring = !Object.values(errorValidations).reduce((prev, curr) => prev && curr, true);

  return (
    <>
      <div className="px-5">
        <AccessPanel user={values} addUser />
      </div>
      <div className="px-5 pt-1 pb-5 row">
        <div className="col-6 justify-content-start">
          <button
            type="button"
            className="me-3 px-4 btn btn-secondary"
            onClick={() => dispatch({ type: 'CHANGE_ADD_USER_PAGE', page: 'info' })}
            disabled={saving}
          >
            <FontAwesomeIcon icon={faAngleLeft} size="lg" className="me-2" />
            Back
          </button>
        </div>
        <div className="col-6 justify-content-end" style={{ display: 'flex' }}>
          <button
            type="button"
            className="me-3 text-white px-4 btn btn-primary"
            onClick={() => handleSave()}
            disabled={saving || erroring}
            style={{ maxHeight: '38px' }}
          >
            <FontAwesomeIcon icon={faSave} size="lg" className="me-2" />
            Save
            {saving && (
              <Spinner size="20" color="white" className="ms-2" />
            )}
          </button>
          <button
            type="button"
            className="px-4 btn btn-outline-dark"
            onClick={() => close()}
            disabled={saving}
            style={{ maxHeight: '38px' }}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </button>
        </div>
        <div className="mt-2" style={{ textAlign: 'end' }}>
          <small className="font-weight-bold">
            <FontAwesomeIcon icon={faInfoCircle} size="lg" className="me-2" />
            New users will be prompted for password reset at login.
          </small>
        </div>
        {errors.other && (
          <div className="form-text text-danger">{errors.other}</div>
        )}
        {errors.email && (
          <div className="form-text text-danger">Error: Email already in use</div>
        )}
        {errors.npn && (
          <div className="form-text text-danger">Error: NPN already in use</div>
        )}
      </div>
    </>
  );
}
